import { render, staticRenderFns } from "./ItemPdf.vue?vue&type=template&id=8609441e"
import script from "./ItemPdf.vue?vue&type=script&lang=js"
export * from "./ItemPdf.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports